import React from "react";

function Footer(){
    var ano = new Date().getFullYear();

        return <section id="footer">
            <p>Desenvolvido por R6 Software - {ano}</p>
            <img src="/imagens/logo_fundo_branco.png" alt="Logo R6 ERP" width="110" height="40"/>
        </section>
}

export default Footer;